import { Grid } from '@enterprise-ui/canvas-ui-react';
import { EnterpriseIcon, PlusIcon } from '@enterprise-ui/icons';
import React from 'react';

function defaultOptionRenderer(option, values) {
  if (option.isNew && Array.isArray(values) ? !(values !== null && values !== void 0 && values.some(function (checkedValue) {
    return checkedValue.label === option.label;
  })) : option.isNew) {
    return /*#__PURE__*/React.createElement(Grid.Container, {
      spacing: "dense",
      align: "center",
      className: "C-CustomValue"
    }, /*#__PURE__*/React.createElement(Grid.Item, {
      xs: 0.5,
      spacing: "dense",
      className: "hc-pr-xs"
    }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
      icon: PlusIcon
    })), /*#__PURE__*/React.createElement(Grid.Item, {
      className: "hc-pb-xs hc-pl-none"
    }, "Create '".concat(option.label, "'")));
  }
  return option.label;
}

export { defaultOptionRenderer as default };
